<template>
    <section>
        <!--工具条-->
        <el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
            <el-form :inline="true" >
                <el-form-item>
                    <el-button type="primary" @click="handleAdd">新增</el-button>
                </el-form-item>
            </el-form>
        </el-col>

        <el-table :data="skills" highlight-current-row border stripe v-loading="listLoading"
                  @selection-change="selsChange"
                  style="width: 100%;text-align: center">
            <el-table-column prop="no" label="编号">
            </el-table-column>
            <el-table-column prop="label" label="技能标签">
            </el-table-column>
            <el-table-column prop="remark" label="备注">
            </el-table-column>

            <el-table-column label="操作">
                <template slot-scope="scope">
                    <el-button type="primary" size="small" @click="edit(scope.$index, scope.row)">编辑</el-button>
                    <el-button type="danger" size="small" @click="del(scope.$index, scope.row)">删除</el-button>
                </template>
            </el-table-column>
        </el-table>

        <!--工具条-->
        <el-col :span="24" class="toolbar">
            <el-pagination layout="prev, pager, next" @current-change="handleCurrentChange" :page-size="rowCount"
                           :total="total" style="float:right;">
            </el-pagination>
        </el-col>

        <!--编辑界面-->
        <el-dialog title="编辑" v-model="editFormVisible" :close-on-click-modal="false">
            <el-form :model="editForm" label-width="120px" ref="editForm">
                <el-form-item label="技能标签" class="require">
                    <el-input v-model="editForm.label" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="备注">
                    <el-input v-model="editForm.remark" auto-complete="off"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click.native="editFormVisible = false">取消</el-button>
                <el-button type="primary" @click.native="editSubmit" :loading="editLoading">提交</el-button>
            </div>
        </el-dialog>

        <!--新增界面-->
        <el-dialog title="新增" v-model="addFormVisible" :close-on-click-modal="false">
            <el-form :model="addForm" label-width="120px" ref="addForm">

                <el-form-item label="技能标签" class="require">
                    <el-input v-model="addForm.label" auto-complete="off"></el-input>
                </el-form-item>

                <el-form-item label="备注">
                    <el-input v-model="addForm.remark" auto-complete="off"></el-input>
                </el-form-item>

            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click.native="addFormVisible = false">取消</el-button>
                <el-button type="primary" @click.native="addSubmit" :loading="addLoading">提交</el-button>
            </div>
        </el-dialog>

    </section>
</template>

<script>
    import util from '../../common/js/util'
    import NProgress from 'nprogress'
    import {requestPost} from '../../api/api';
    import {data} from "../../common/data";

    export default {
        data() {
            return {

                skills: [],
                total: 0,
                rowCount: 20,
                pageNO: 1,
                listLoading: false,
                sels: [],

                editFormVisible: false,
                editLoading: false,
                editForm: {
                    label: '',
                    remark: ''

                },

                addFormVisible: false,
                addLoading: false,
                addForm: {
                    label: '',
                    remark: ''
                }

            }
        },
        methods: {

            handleCurrentChange(val) {
                this.pageNO = val;
                this.getskills();
            },

            getskills() {

                let para = {
                    rowCount: this.rowCount,
                    pageNO: this.pageNO
                };
                this.listLoading = true;
                NProgress.start();
                let url = 'skill/getPage.do';
                requestPost(this, url, para).then((res) => {

                    if (res != '') {
                        this.total = res.total;
                        this.skills = res.data;
                    }
                    this.listLoading = false;
                    NProgress.done();
                });
            },
            //删除
            del: function (index, row) {
                this.$confirm('确认删除该记录吗?', '提示', {
                    type: 'warning'
                }).then(() => {
                    this.listLoading = true;
                    NProgress.start();
                    let para = {no: row.no};
                    let url = 'skill/del.do';
                    requestPost(this, url, para).then((res) => {
                        this.listLoading = false;
                        NProgress.done();
                        if (res != '') {
                            util.successTip(this);
                            this.getskills();
                        }
                    });
                }).catch(() => {

                });
            },
            //显示编辑界面
            edit: function (index, row) {
                this.editFormVisible = true;
                this.editForm = Object.assign({}, row);
            },
            //显示新增界面
            handleAdd: function () {
                this.addFormVisible = true;
            },
            //编辑
            editSubmit: function () {
                this.$refs.editForm.validate((valid) => {
                    if (valid) {
                        this.$confirm('确认提交吗？', '提示', {}).then(() => {
                            this.editLoading = true;
                            NProgress.start();
                            let para = Object.assign({}, this.editForm);
                            let url = 'skill/update.do';
                            requestPost(this, url, para).then((res) => {
                                this.editLoading = false;
                                NProgress.done();
                                if (res != '') {
                                    util.successTip(this);
                                    this.$refs['editForm'].resetFields();
                                    this.editFormVisible = false;
                                    this.getskills();
                                }

                            });
                        });
                    }
                });
            },

            addSubmit: function () {
                this.$refs.addForm.validate((valid) => {
                    if (valid) {
                        this.$confirm('确认提交吗？', '提示', {}).then(() => {
                            this.addLoading = true;
                            NProgress.start();
                            let para = Object.assign({}, this.addForm);
                            let url = 'skill/add.do';
                            requestPost(this, url, para).then((res) => {
                                this.addLoading = false;
                                NProgress.done();
                                if (res !== '') {
                                    util.successTip(this);
                                    this.$refs['addForm'].resetFields();
                                    this.addFormVisible = false;
                                    this.getskills();
                                }
                            });
                        });
                    }
                });
            },

            selsChange: function (sels) {
                this.sels = sels;
            }

        },
        mounted() {
            this.getskills();
        },
        activated: function () {

        }
    }

</script>


<style scope lang="scss" type="text/scss">
    @import '../../styles/vars.scss';
</style>


// WEBPACK FOOTER //
// skillManage.vue?5ffc1874